module.exports = __webpack_public_path__ + "img/flame_icon.6f7c5840.svg";